import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

import { PublicRoutes } from '../../../routes/public';
import { PrivateRoutes } from '../../../routes/private';
import LogoReact from '../../common/LogoReact';
import { logout } from '../../../context/redux/actions/authAction';
import { addLog } from '../../../context/redux/actions/logAction';

import './index.css';


function Header() {

    const dispatch = useDispatch();

    const {isAuthenticated, username} = useSelector( (state) => state.auth );

    const handleClick = () => {
        dispatch( logout() );
        dispatch( addLog(`${username}: logout`) );
    }

    return (
        <nav className="header navbar navbar-expand-sm navbar-dark bg-dark">

            <Link to="/" className="navbar-brand titulo p-left-20">Corazón de guerrero</Link>

            <div className="collapse navbar-collapse">
                <Link to="/" className="navbar-brand subtitulo p-left-10">El camino de los miedos</Link>

                {/* <div className="navbar-nav navbar-routes">
                {!isAuthenticated && (
                    PublicRoutes.filter(item => item.showMenu).map((route, index) => (
                        <NavLink key={index} 
                            to={route.path}
                            className="nav-item nav-link subtitulo"
                        > {route.title} </NavLink>
                    ))
                )}
                {isAuthenticated && (
                    PrivateRoutes.filter(item => item.showMenu).map((route, index) => (
                        <NavLink key={index} 
                            to={route.path}
                            className="nav-item nav-link subtitulo"
                        > {route.title} </NavLink>
                    ))
                )}
                </div>
                <div className="navbar-nav">
                {isAuthenticated && (
                    <a onClick={ handleClick } className="nav-item nav-link p-right-10">Logout</a>
                )}
                </div> */}
            </div>

            <div className="navbar-nav autor-wrapper">
                <Link to="/" className="nav-item nav-link p-right-20 autor">Gonzalo Cajaraville</Link>
            </div>

        </nav>
    )
}

export default Header;